import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { BiCoinStack } from 'react-icons/bi';
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md';
import img1 from '../../../assets/img/Industries/TelecomandNetworks/iot.png';

import { MdOutlineSpaceDashboard } from "react-icons/md";
import { CiCircleCheck } from "react-icons/ci";

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            IoT-Enabled Connectivity 
            </h1>
            <p className="text-lg text-gray-600">
            Enable seamless device integration, scalable IoT platforms, and connected infrastructure for smart cities and industrial automation.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineSpaceDashboard className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                Smart Device Integration
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Facilitate seamless IoT device connectivity across networks for applications in smart homes, healthcare, and industrial automation.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineDevices className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">IoT Platform Development</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Build robust platforms to manage and scale IoT services efficiently.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <CiCircleCheck className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                Connected Infrastructure
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Support smart city initiatives with reliable IoT-driven networks for public utilities, transportation, and security.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
